export const NB_MAX_REGION = 1

export const ALL_REGIONS_LABEL = 'Régions les plus attractives'
export const ALL_REGION_TYPE = 'ALL_REGION'
export const DEPARTEMENT_TYPE = 'Département'
export const REGION_TYPE = 'Régions'
export const CITY_TYPE = 'Villes'

export const PROJECTS = [
    {
        key: 'déménage',
        option: 'je déménage prochainement'
    },
    {
        key: 'logement',
        option: 'je recherche un logement',
    },
    {
        key: 'emploi',
        option: 'je recherche un emploi',
    }
]

export const JOB_SITUATIONS = [
    {
        key: "demandeur d'emploi",
        option: "je suis demandeur d'emploi",
    },
    {
        key: 'salarié',
        option: 'je suis salarié',
    },
    {
        key: 'alternance',
        option: 'je suis alternant',
    }
]

export const AGE_SITUATIONS = [
    {
        key: 'moins de 26 ans',
        option: "j'ai moins de 26 ans",
    },
    {
        key: 'plus de 26 ans',
        option: "j'ai plus de 26 ans",
    }
]